import { X } from "lucide-react";
import React from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
  className?: string;
}

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  title,
  className = "",
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex h-full w-full items-end justify-center sm:items-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={onClose}
      />

      {/* Modal Content */}
      <div
        className={`relative bg-white rounded-lg shadow-xl max-w-4xl w-full mx-0 sm:mx-4 max-h-[92vh] sm:max-h-[90vh] overflow-hidden rounded-b-none sm:rounded-b-lg ${className}`}
      >
        {/* Header */}
        {title && (
          <div className="flex items-center justify-between pt-5 px-4 sm:pt-6 sm:px-6">
            <h2 className="text-[18px] font-semibold text-hColor">{title}</h2>
            <button
              onClick={onClose}
              className="p-1 hover:bg-gray-100 rounded-full transition-colors"
            >
              <X size={20} className="text-hColor" />
            </button>
          </div>
        )}

        {/* Content */}
        <div className="overflow-y-auto max-h-[calc(85vh-60px)] sm:max-h-[calc(89vh-100px)]">
          {children}
        </div>
      </div>
    </div>
  );
};

// StepIndicator.tsx - Progress Steps Component
interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

export const StepIndicator: React.FC<StepIndicatorProps> = ({
  currentStep,
  totalSteps,
}) => {
  return (
    <div className="flex items-center justify-center space-x-2 p-6">
      {Array.from({ length: totalSteps }, (_, index) => (
        <div
          key={index}
          className={`h-2 flex-1 rounded-full transition-colors ${
            index < currentStep ? "bg-primary" : "bg-gray-200"
          }`}
        />
      ))}
    </div>
  );
};
